import template from './chart-date-filter.html';

class ChartDateFilterComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.include_dates = ko.observable(params.include_dates || false);
		this.reload = ko_helper.safe_observable(params.reload);

		this.date_start_input = ko.observable(params.date_start ? params.date_start() : '');
		this.date_end_input = ko.observable(params.date_end ? params.date_end() : '');
		this.time_span_interval_input = ko.observable(params.time_span_interval());
		this.time_span_input = ko.observable(params.time_span());

		// Date Observables
		this.date_start = ko_helper.safe_observable(params.date_start);
		this.date_end = ko_helper.safe_observable(params.date_end);

		// Interval Observables
		this.time_span_interval = ko_helper.safe_observable(params);
		this.time_span = ko_helper.safe_observable();

		this.date_start_input.subscribe((newValue) => {
			if (this.is_valid_date(newValue))
				this.date_start(newValue);
		});

		this.date_end_input.subscribe((newValue) => {
			if (this.is_valid_date(newValue))
				this.date_end(newValue);
		});

		this.time_span_interval_input.subscribe((newValue) => {
			if (newValue)
				this.time_span_interval(newValue);
		});

		this.time_span_input.subscribe((newValue) => {
			if (newValue)
				this.time_span(newValue);
		});
	}

	reload_filters()
	{
		this.reload(Date.now());
	}

	is_valid_date (date_string)
	{
		return moment(date_string, 'YYYY-MM-DD', true).isValid();
	}
}

export default {
	name: 'erp-graph-filter',
	viewModel: ChartDateFilterComponentViewModel,
	module_type: 'ko',
	template: template
}
